module.exports = __webpack_public_path__ + "static/media/notchasing.818ff2d8.svg";